import React from 'react';
import PropTypes from 'prop-types';
import WidgetContainer from 'components/widget/WidgetContainer';
import TwoColsWidgetLayout from 'layouts/TwoColsWidgetLayout';
import TextLink from 'components/TextLink';
import CTAIconWrapper from 'components/widget/CTAIconWrapper';
import { ReactComponent as LetterBoxSvg } from 'images/letterbox.svg';
import topupsContainerPath from 'containers/paths/OrderTopupsContainerPath';

const OrderTopupWidget = ({ className }) => {
  const classes = ['OrderTopupWidget', className];

  return (
    <WidgetContainer className={classes.filter((c) => !!c).join(' ')}>
      <TwoColsWidgetLayout>
        <div>
          <h2 className="no_margin_top">Running low on lenses?</h2>
          <TextLink
            rightChevron
            dataLayer={{ action: 'Top Up', label: 'Top Up - Start' }}
            props={{ to: topupsContainerPath() }}
          >
            Order top-ups
          </TextLink>
        </div>
        <CTAIconWrapper>
          <LetterBoxSvg />
        </CTAIconWrapper>
      </TwoColsWidgetLayout>
    </WidgetContainer>
  );
};

OrderTopupWidget.displayName = 'OrderTopupWidget';

OrderTopupWidget.propTypes = {
  className: PropTypes.string,
};

OrderTopupWidget.defaultProps = {
  className: null,
};

export default OrderTopupWidget;
